import { render, staticRenderFns } from "./BulletTextIcon.vue?vue&type=template&id=703b6257&scoped=true"
import script from "./BulletTextIcon.vue?vue&type=script&lang=js"
export * from "./BulletTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b6257",
  null
  
)

export default component.exports